// extracted by mini-css-extract-plugin
module.exports = {"mobilemenu":"MobileMenu_mobilemenu__1-PcQ"};